import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('CATEGORY').plugin(axiosPlugin);

let fetchAlbumAction = redux.fetchActionGetOne();

export const fetchCategory = (categoryId, query = {}) => fetchAlbumAction(`/categories/${categoryId}?${queryString.stringify(query)}`);
export const resetCategory = () => redux.actions.reset();

export const category = redux.reducer();
